/**
 * Copia en el navegador del borrador de conteo, para no perderlo al salir de la
 * pantalla o si el móvil recarga la aplicación. Puede no estar disponible
 * (navegación privada, almacenamiento bloqueado): entonces no hace nada.
 *
 * DECISION: se guarda por REFERENCIA del artículo, no por id de línea: editar un
 * inventario PENDIENTE renumera sus líneas desde 1 (PUT del backend), y por id
 * el borrador recuperado caería en otro artículo.
 */

const PREFIJO = "mandatelo:inventario-conteo:";
const CADUCIDAD_MS = 7 * 24 * 60 * 60 * 1000;

const clave = (inventarioId, preparadorId) => `${PREFIJO}${inventarioId}:${preparadorId}`;

/**
 * Lee el borrador guardado de un inventario; descarta el caducado o ilegible
 * @param {number} inventarioId - Id del inventario
 * @param {number} preparadorId - Preparador asignado (el dispositivo puede ser compartido)
 * @returns {{porReferencia: Object<string, Object<string, number>>, almacenGeneral: string|null}|null} Lo guardado, o null
 */
export const leerBorradorLocal = (inventarioId, preparadorId) => {
    try {
        const texto = window.localStorage.getItem(clave(inventarioId, preparadorId));
        if (!texto) return null;
        const datos = JSON.parse(texto);
        const caducado = !datos?.guardadoEn || Date.now() - datos.guardadoEn > CADUCIDAD_MS;
        if (caducado || !datos.porReferencia || typeof datos.porReferencia !== "object") {
            window.localStorage.removeItem(clave(inventarioId, preparadorId));
            return null;
        }
        return { porReferencia: datos.porReferencia, almacenGeneral: datos.almacenGeneral ?? null };
    } catch {
        return null;
    }
};

/**
 * Guarda el borrador de un inventario, o lo borra si no queda nada que guardar
 * @param {number} inventarioId - Id del inventario
 * @param {number} preparadorId - Preparador asignado
 * @param {{porReferencia: Object<string, Object<string, number>>, almacenGeneral: string|null}|null} datos - Lo que guardar, o null para borrar
 */
export const escribirBorradorLocal = (inventarioId, preparadorId, datos) => {
    try {
        if (!datos) window.localStorage.removeItem(clave(inventarioId, preparadorId));
        else window.localStorage.setItem(clave(inventarioId, preparadorId), JSON.stringify({ ...datos, guardadoEn: Date.now() }));
    } catch {
        // Sin almacenamiento disponible: el borrador sigue en memoria como siempre
    }
};
